import { Link } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { teamMembers } from '@/mocks/team';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-blue-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-11 h-11 rounded-full overflow-hidden bg-white shrink-0">
                <img src="https://static.readdy.ai/image/c7416925641f36c4b72e81cd7ba1ed46/1ae22aa63f51b461cd10a9da4895730b.jpeg" alt="Vanpolat Tesisat" className="w-full h-full object-cover" />
              </div>
              <div>
                <p className="font-extrabold text-lg leading-none" style={{ fontFamily: 'Poppins, sans-serif' }}>Vanpolat</p>
                <p className="text-blue-300 text-xs mt-0.5">Tesisat</p>
              </div>
            </div>
            <p className="text-blue-200 text-sm leading-relaxed mb-4">{t('footer.desc')}</p>
            <div className="flex gap-2">
              <a href="https://wa.me/905076074165?text=Merhaba%2C%20tesisat%20konusunda%20yard%C4%B1m%20istiyorum."
                target="_blank" rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center bg-green-500 hover:bg-green-600 rounded-full transition-colors cursor-pointer">
                <i className="ri-whatsapp-line"></i>
              </a>
              <a href="tel:+905076074165"
                className="w-9 h-9 flex items-center justify-center bg-blue-600 hover:bg-blue-500 rounded-full transition-colors cursor-pointer">
                <i className="ri-phone-fill"></i>
              </a>
              <a href="https://www.instagram.com/" target="_blank" rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center bg-blue-700 hover:bg-pink-600 rounded-full transition-colors cursor-pointer">
                <i className="ri-instagram-line"></i>
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <p className="text-blue-300 text-xs font-bold uppercase tracking-wider mb-4">{t('footer.quickLinks')}</p>
            <ul className="space-y-2 mb-6">
              {[
                { label: t('footer.link.home'), to: '/' },
                { label: t('footer.link.services'), to: '/hizmetler' },
                { label: t('footer.link.about'), to: '/bizim' },
                { label: t('footer.link.booking'), to: '/randevu' },
              ].map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-blue-200 hover:text-white text-sm flex items-center gap-2 transition-colors cursor-pointer">
                    <i className="ri-arrow-right-s-line text-blue-400 text-xs"></i>{l.label}
                  </Link>
                </li>
              ))}
            </ul>
            <p className="text-blue-300 text-xs font-bold uppercase tracking-wider mb-4">{t('footer.servicesTitle')}</p>
            <ul className="space-y-2">
              {[1, 2, 3, 4, 5].map((n) => (
                <li key={n}>
                  <Link to="/hizmetler" className="text-blue-200 hover:text-white text-sm flex items-center gap-2 transition-colors cursor-pointer">
                    <i className="ri-arrow-right-s-line text-blue-400 text-xs"></i>{t(`footer.svc.${n}`)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Team */}
          <div>
            <p className="text-blue-300 text-xs font-bold uppercase tracking-wider mb-4">{t('footer.teamTitle')}</p>
            <ul className="space-y-4">
              {teamMembers.map((m) => (
                <li key={m.id}>
                  <p className="text-white text-sm font-bold">{m.name}</p>
                  <a href={m.phoneHref} className="text-blue-200 hover:text-white text-sm transition-colors cursor-pointer">{m.phone}</a>
                  <div className="flex gap-2 mt-1.5">
                    <a href={m.phoneHref} className="text-xs text-blue-300 hover:text-white border border-blue-700 hover:border-blue-400 rounded-lg px-2 py-1 transition-colors cursor-pointer whitespace-nowrap">Ara</a>
                    <a href={m.whatsapp} target="_blank" rel="nofollow noreferrer" className="text-xs text-green-300 hover:text-white border border-green-800 hover:border-green-500 rounded-lg px-2 py-1 transition-colors cursor-pointer whitespace-nowrap">WhatsApp</a>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="text-blue-300 text-xs font-bold uppercase tracking-wider mb-4">{t('footer.contactTitle')}</p>
            <ul className="space-y-3 mb-5">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-2-line text-blue-400 mt-0.5 shrink-0 text-base"></i>
                <div>
                  <p className="text-white text-sm font-semibold">Vanpolat Tesisat</p>
                  <a href="tel:+905076074165" className="text-blue-300 hover:text-white text-sm font-semibold transition-colors cursor-pointer">0507 607 4165</a>
                  <p className="text-blue-200 text-sm leading-snug mt-1">Van Merkez, Van ili</p>
                  <p className="text-blue-200 text-sm leading-snug">65000 Van / Türkiye</p>
                  <a
                    href="https://maps.google.com/?q=Van,+Türkiye"
                    target="_blank"
                    rel="nofollow noreferrer"
                    className="inline-flex items-center gap-1 text-xs text-blue-400 hover:text-white mt-1 transition-colors cursor-pointer"
                  >
                    <i className="ri-external-link-line"></i> Haritada Gör
                  </a>
                </div>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-fill text-blue-400 shrink-0"></i>
                <a href="tel:+905076074165" className="text-blue-200 hover:text-white text-sm transition-colors cursor-pointer">0507 607 4165</a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-blue-400 shrink-0"></i>
                <span className="text-blue-200 text-sm">{t('footer.hours')}</span>
              </li>
            </ul>
            <div className="flex flex-col gap-2">
              <a href="tel:+905076074165"
                className="flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-500 text-white text-sm font-bold py-2.5 rounded-xl transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-phone-fill"></i> {t('footer.call')}
              </a>
              <a href="https://wa.me/905076074165?text=Merhaba%2C%20tesisat%20konusunda%20yard%C4%B1m%20istiyorum."
                target="_blank" rel="nofollow noreferrer"
                className="flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white text-sm font-bold py-2.5 rounded-xl transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-whatsapp-line"></i> {t('footer.wa')}
              </a>
            </div>
          </div>
        </div>

        {/* Google Maps */}
        <div className="mt-10">
          <div className="flex items-center gap-2 mb-3">
            <i className="ri-map-pin-2-fill text-blue-400 text-base"></i>
            <p className="text-blue-300 text-xs font-bold uppercase tracking-wider">Hizmet Bölgemiz — Van ve Çevre İlçeler</p>
          </div>
          <div className="rounded-xl overflow-hidden border border-blue-800" style={{ height: 220 }}>
            <iframe
              title="Vanpolat Tesisat Konum — Van, Türkiye"
              src="https://www.google.com/maps?q=Van%2C+T%C3%BCrkiye&output=embed&z=11"
              width="100%"
              height="100%"
              style={{ border: 0, display: 'block' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          <p className="text-blue-400 text-xs mt-2 flex items-center gap-1.5">
            <i className="ri-map-pin-line"></i>
            Van Merkez, Erciş, Edremit, Tuşba ve tüm Van ili genelinde hizmet veriyoruz.
          </p>
        </div>
      </div>

      <div className="border-t border-blue-800">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-blue-300 text-xs">{t('footer.copyright')}</p>
          <p className="text-blue-400 text-xs">{t('footer.area')}</p>
        </div>
      </div>
    </footer>
  );
}
